const CONSTANTS = {
  APP_CONFIG: 'appConfig',
  AIMEOS_JSON_API: 'aimeosJsonApi',
  BASE_URL: 'baseUrl',
  TERMS: 'terms',
  CURRENT: 'current',
  CODE: 'code',
  DATA: 'data',
  LANGUAGE: 'language',
  LANGUAGES: 'languages',
  LINKS: 'links',
  SELF: 'self',
  TITLE: 'title',
  URL: 'url',
  RELATIONSHIPS: 'relationships',
  SEARCH_DETAIL: 'searchDetail',
  SEARCH_OVERVIEW: 'searchOverview',
  SPARE_PARTS_GROUPS: 'sparePartsGroups',
  CATALOG: 'catalog',

  // MESSAGING
  MESSAGING_CONFIG: 'messagingConfig',
  MESSAGING_DOMAIN: 'domain',
  MESSAGING_WS_PORT: 'wsPort',
  MESSAGING_TOKEN: 'messagingToken',
  TOKEN: 'token',

  // HUBSPOT MESSAGING SERVICE
  HUBSPOT_MIDDLEWARE_FORM_API: 'hubspotMiddlewareFormApi',
  HUBSPOT_MIDDLEWARE_VISITOR_IDENTIFICATION_API: 'hubspotMiddlewareVisitorIdentificationApi',

  // ZENLOOP
  ZENLOOP: 'zenloop',
}

const PATHS = {
  BASE_URL: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LINKS}.${CONSTANTS.BASE_URL}`,
  CURRENT_LANG: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LANGUAGE}.${CONSTANTS.CURRENT}`,
  CURRENT_LANG_CODE: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LANGUAGE}.${CONSTANTS.CURRENT}.${CONSTANTS.CODE}`,
  CURRENT_LANG_URL: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LANGUAGE}.${CONSTANTS.CURRENT}.${CONSTANTS.URL}`,
  LANGUAGES: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.RELATIONSHIPS}.${CONSTANTS.LANGUAGES}.${CONSTANTS.DATA}`,
  LINKS: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LINKS}`,
  AIMEOS_JSON_API_LINK: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LINKS}.${CONSTANTS.AIMEOS_JSON_API}`,
  SEARCH_DETAIL_LINK: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LINKS}.${CONSTANTS.SEARCH_DETAIL}`,
  SEARCH_OVERVIEW_LINK: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LINKS}.${CONSTANTS.SEARCH_OVERVIEW}`,
  TERMS: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LINKS}.${CONSTANTS.TERMS}`,
  SPARE_PARTS_GROUPS: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.SPARE_PARTS_GROUPS}`,
  CATALOG: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.CATALOG}`,
  MESSAGING_DOMAIN: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LINKS}.${CONSTANTS.MESSAGING_CONFIG}.${CONSTANTS.MESSAGING_DOMAIN}`,
  MESSAGING_WS_PORT: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LINKS}.${CONSTANTS.MESSAGING_CONFIG}.${CONSTANTS.MESSAGING_WS_PORT}`,
  MESSAGING_TOKEN: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.MESSAGING_TOKEN}.${CONSTANTS.TOKEN}`,
  HUBSPOT_MIDDLEWARE_FORM_API: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LINKS}.${CONSTANTS.HUBSPOT_MIDDLEWARE_FORM_API}`,
  HUBSPOT_MIDDLEWARE_VISITOR_IDENTIFICATION_API: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.LINKS}.${CONSTANTS.HUBSPOT_MIDDLEWARE_VISITOR_IDENTIFICATION_API}`,
  ZENLOOP: `${CONSTANTS.APP_CONFIG}.${CONSTANTS.ZENLOOP}`,
}

export default {
  ...CONSTANTS,
  PATHS,
}
